import config from 'constants/config'

function determineNextLoyaltyTier(tier: App.LoyaltyTier): App.LoyaltyTier | undefined {
  const currentTierIndex = config.loyalty.tiersOrder.findIndex((t) => t === tier)
  return config.loyalty.tiersOrder[currentTierIndex + 1]
}

export default determineNextLoyaltyTier
